module.exports = __webpack_public_path__ + "media/country_flags/ge-bd1cf552.png";